/**
 * ScrollToTop — on route change, scroll to the top of the new page.
 * If the URL carries an in-page hash (e.g. /for-institutions#pilot-form),
 * scroll to that element instead — retrying briefly so lazy-loaded pages
 * have time to render the target.
 *
 * Mounted once inside <BrowserRouter> in App.js.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (hash && !hash.includes("session_id=")) {
      const id = hash.slice(1);
      let tries = 0;
      const attempt = () => {
        const el = document.getElementById(id);
        if (el) { el.scrollIntoView({ behavior: "auto", block: "start" }); return; }
        if (++tries < 8) setTimeout(attempt, 150);
      };
      const raf = requestAnimationFrame(attempt);
      return () => cancelAnimationFrame(raf);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const raf = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname, search, hash]);
  return null;
}
